import { useSelector } from 'react-redux';

import { IApplicationState } from '@store';
import { Themes } from '@models';

export type AppThemes = 'adaptive-theme' | 'clonoseq-theme' | 'immunoseq-theme';

/*
 * Custom hook to change app's UI themes based on CSS classes.
 * CSS theme class is applied in HTML body element
 */

/**
 * TODO: we may not need to call this explicitly to update the current theme.
 * However since some components need to know the current theme, we may want to
 * provide a `get` function.
 */
export const useTheme = () => {
  const activeProjectId = useSelector(
    (state: IApplicationState) => state.projectPicker.activeProjectId
  );
  const projectsList = useSelector(
    (state: IApplicationState) => state.projectPicker.projectsList
  );

  if (activeProjectId && projectsList) {
    const activeProject = projectsList.filter(
      ({ projectId }) => projectId === activeProjectId
    )[0];
    if (activeProject) {
      return switchTheme(Themes[activeProject.brand]);
    }
  } else {
    const currentThemeInLocalStorage = localStorage.getItem('current-theme');
    const targetTheme: AppThemes = currentThemeInLocalStorage
      ? (currentThemeInLocalStorage as AppThemes)
      : Themes.Adaptive;
    return switchTheme(targetTheme);
  }

  function switchTheme(newTheme: AppThemes) {
    const classList = document.body.classList;
    if (!classList.contains(newTheme)) {
      const listOfThemes: AppThemes[] = [
        'adaptive-theme',
        'clonoseq-theme',
        'immunoseq-theme',
      ];
      const toBeRemoved: string[] = listOfThemes.filter(
        (theme) => theme !== newTheme
      );
      classList.remove(...toBeRemoved);
      classList.add(newTheme);
      localStorage.setItem('current-theme', newTheme);
    }
    return newTheme;
  }
};
